export const TOGGLE_SECTION = 'TOGGLE_SECTION';
